import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortMessages',
  pure: true // Gardez la pipe pure pour éviter les problèmes de performances
})
export class SortMessagesPipe implements PipeTransform {
  transform(chats: any[], sortField: string = 'lastMessageTimeStamp'): any[] {
    if (!chats || chats.length === 0) return [];
    return chats.sort((a, b) => {
      const dateA = new Date(a[sortField]).getTime();
      const dateB = new Date(b[sortField]).getTime();
      return dateB - dateA; // Tri décroissant (le plus récent en premier)
    });
  }
}
